import React from 'react';
import {Button} from '@mui/material';
import {MyAppointmentsEnum} from 'presentation/constants';
import {BookingErrorState} from 'presentation/modules/booking/shared/ui/components/BookingErrorState';
import {BookingLoadingState} from 'presentation/modules/booking/shared/ui/components/BookingLoadingState';
import {translations} from 'presentation/translations-new';
import {Navigate} from 'react-router-dom';
import {useHealthConfirmationBooking} from './hooks/useHealthConfirmationBooking';
import {HealthConfirmationBookingContent} from './components/HealthConfirmationBookingContent';
import {HealthConfirmationBookingContentNew} from './components/HealthConfirmationBookingContentNew';

const {loadError, loading} = translations['pt-br'].commons;

const {confirmationBooking, seeMyAppointments} = translations['pt-br'].privateFlow.bookingFlow;

export function HealthConfirmationBooking() {
	const {
		goToMyAppointments,
		confirmedBookAppointment,
		appointmentsListLoading,
		appointmentsListError,
		refresh,
		showNewConfirmationPage,
	} = useHealthConfirmationBooking();

	if (appointmentsListLoading) {
		return (
			<BookingLoadingState
				pageTitle={confirmationBooking}
				loadingText={loading}
				hideBackBtn
			/>
		);
	}

	if (!confirmedBookAppointment) {
		return <Navigate to={MyAppointmentsEnum.MY_APPOINTMENTS} />;
	}

	if (appointmentsListError) {
		return (
			<BookingErrorState
				pageTitle={confirmationBooking}
				errorTitle={loadError}
				handleBack={goToMyAppointments}
				handleRefresh={refresh}>
				<Button
					size="large"
					sx={{mx: 'auto', mt: 2, width: 'min-content'}}
					onClick={goToMyAppointments}>
					{seeMyAppointments}
				</Button>
			</BookingErrorState>
		);
	}

	return showNewConfirmationPage ? (
		<HealthConfirmationBookingContentNew
			bookedAppointment={confirmedBookAppointment}
			goToMyAppointments={goToMyAppointments}
		/>
	) : (
		<HealthConfirmationBookingContent
			bookedAppointment={confirmedBookAppointment}
			goToMyAppointments={goToMyAppointments}
		/>
	);
}
